import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { SetOriginLocationActionStep } from "@redotech/redo-model/advanced-flow/oms/actions";
import { RedoFulfillmentLocation } from "@redotech/redo-model/fulfillments/fulfillment-location";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";
import { PartialWithRequiredType } from ".";

export const OriginLocationDropdown = memo(function OriginLocationDropdown({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetOriginLocationActionStep>;
  setStep: (step: PartialWithRequiredType<SetOriginLocationActionStep>) => void;
}) {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  const locationsLoad = useLoad(async () => {
    try {
      const { locations } = await rpcClient.getLocationsWithFulfillsFor({});
      return locations;
    } catch (error) {
      console.error(error);
      return [];
    }
  }, []);

  const listItems: RedoListItem<RedoFulfillmentLocation>[] = useMemo(() => {
    return (
      locationsLoad.value?.map((location) => ({
        id: location.externalId,
        value: location,
        type: "text",
        text: location.name,
      })) || []
    );
  }, [locationsLoad.value]);

  return (
    <RedoSingleSelectDropdownInput
      options={listItems}
      optionSelected={(option) =>
        setStep({ ...step, locationId: option.item.value.externalId })
      }
      selectedItem={listItems.find((item) => item.id === step.locationId)}
    />
  );
});
